import { useEffect } from 'react'

const ExternalRedirect = () => {
  useEffect(() => {
    window.location = 'http://hopshop.ru'
  })
  return null
}

export default ExternalRedirect